import { render, staticRenderFns } from "./InvoicesDash.vue?vue&type=template&id=64d3470c"
import script from "./InvoicesDash.vue?vue&type=script&lang=js"
export * from "./InvoicesDash.vue?vue&type=script&lang=js"
import style0 from "./InvoicesDash.vue?vue&type=style&index=0&id=64d3470c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports